import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';
// import VueGtag from 'vue-gtag';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from './store/index';
import './auth';

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});
Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '',
      beforeEnter: async (to, from, next) => {
        if (!store.state?.content?.content?.items?.length) {
          await store.dispatch('content/read', null, { root: true });
        }
        return next();
      },
    },
    {
      path: '/not-found',
    },
    {
      path: '/:page',
      beforeEnter: async (to, from, next) => {
        if (!store.state?.content?.content?.items?.length) {
          await store.dispatch('content/read', null, { root: true });
        }

        if (store.state.content.content.items.find((item) => item.tab === to.params.page) || ['', 'login', 'register'].includes(to.params.page)) {
          return next();
        }

        return next({ path: '/not-found' });
      },
    }],
});

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
